import { SeoCrawlerResponse } from "../../../server/types/index.js";
import {
  GetSeoUrlsQueryParams,
  SeoUrl,
  SeoUrlRequest,
} from "../../types/index.js";
import { calculatePagination, fetch } from "../../utils/utils.js";
import { showAlert } from "../alerts.js";
import { createAppAsyncThunk } from "../utils.js";

const actionPrefix = "seo";

export const getSeoUrls = createAppAsyncThunk(
  `${actionPrefix}/getSeoUrls`,
  async (
    {
      siteId,
      params,
      keepExisting,
    }: { siteId: string; params: GetSeoUrlsQueryParams; keepExisting: boolean },
    { dispatch, getState },
  ) => {
    const page = calculatePagination(
      keepExisting,
      getState().seo.urls.allItems.length,
    );

    const data = await fetch({ dispatch })
      .query({ ...params, page }, { omitUndefinedOrNullValues: true })
      .get(`sites/${siteId}/seo/urls`)
      .json<SeoUrl[]>();

    return data;
  },
);

export const patchSeoUrl = createAppAsyncThunk<
  SeoUrl,
  { siteId: string; urlId: string; request: SeoUrlRequest },
  { pendingMeta: { url: SeoUrl | undefined } }
>(
  `${actionPrefix}/patchSeoUrl`,
  async ({ siteId, urlId, request }, { dispatch }) => {
    try {
      const data = await fetch({ dispatch })
        .patch(request, `sites/${siteId}/seo/urls/${urlId}`)
        .json<SeoUrl>();
      return data;
    } catch (error) {
      dispatch(
        showAlert("Beim Aktualisieren der Url ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  },
  {
    dispatchConditionRejection: true,
    condition: ({ urlId }, { getState }) => !!getState().seo.urls.byId[urlId],
    getPendingMeta: ({ arg: { urlId } }, { getState }) => ({
      url: getState().seo.urls.byId[urlId],
    }),
  },
);

export const postSeoUrls = createAppAsyncThunk(
  `${actionPrefix}/postSeoUrls`,
  async (
    { siteId, urls }: { siteId: string; urls: string[] },
    { dispatch },
  ) => {
    try {
      await fetch({ dispatch }).post(urls, `sites/${siteId}/seo/urls`).res();
      dispatch(
        showAlert(`Die Seitenlinks wurden erfolgreich importiert!`, "success"),
      );
    } catch (error) {
      dispatch(
        showAlert(
          "Der Import der Seitenlinks ist fehlgeschlagen. Überprüfen Sie die Eingabe und versuchen Sie es erneut!",
        ),
      );
      throw error;
    }
  },
);

export const getSeoCrawler = createAppAsyncThunk(
  `${actionPrefix}/getSeoCrawler`,
  async (
    { siteId, showLastResult }: { siteId: string; showLastResult: boolean },
    { dispatch },
  ) => {
    const data = await fetch({ dispatch })
      .query({ showLastResult })
      .get(`sites/${siteId}/seo/urls/check`)
      .json<SeoCrawlerResponse>();
    return data;
  },
);

export const postSeoCrawler = createAppAsyncThunk(
  `${actionPrefix}/postSeoCrawler`,
  async (siteId: string, { dispatch }) => {
    try {
      const data = await fetch({ dispatch })
        .post(null, `sites/${siteId}/seo/urls/check`)
        .json<SeoCrawlerResponse>();
      return data;
    } catch (error) {
      dispatch(
        showAlert(
          "Beim Überprüfen der Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut, oder wenden Sie sich an den Support!",
        ),
      );
      throw error;
    }
  },
);
